import { render, staticRenderFns } from "./TipsWechat.vue?vue&type=template&id=fe241a28&scoped=true"
import script from "./TipsWechat.vue?vue&type=script&lang=js"
export * from "./TipsWechat.vue?vue&type=script&lang=js"
import style0 from "./TipsWechat.vue?vue&type=style&index=0&id=fe241a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe241a28",
  null
  
)

export default component.exports